import React from "react";
import BoxCard from "shared/components/box/BoxCard.js";
import { isAssistant } from "shared/utils/env.js";

interface BoxLoginProps {
  assistantUser?: object;
}

const BoxLogin: React.FC<BoxLoginProps> = ({ assistantUser }) => {
  return (
    <BoxCard
      title={"Login required"}
      content={
        <div className="d-flex flex-column flex-md-row">
          <div className="d-flex flex-fill justify-content-center">
            <img
              style={{ width: "120px" }}
              src={isAssistant() ? "/media/images/assistant.png" : "/media/images/coach.png"}
              alt="MFL Assistant"
            />
          </div>

          <div className="d-flex flex-column flex-fill align-items-center justify-content-center px-2">
            <div className="pb-2">
              Connect your Dapper wallet
              <br />
              to access all the features.
            </div>

            <div>
              <button
                className="d-flex flex-row btn btn-info text-white me-1"
                disabled={typeof assistantUser === "undefined"}
              >
                {typeof assistantUser === "undefined" ? "Checking login..." : "Connect"}
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default BoxLogin;
